// extracted by css-extract-rspack-plugin
export default {"body":"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__body-XVOFgO","message":"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__message-vM7_Bp","buttons":"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__buttons-AOslbi"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"body\":\"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__body-XVOFgO\",\"message\":\"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__message-vM7_Bp\",\"buttons\":\"src-modules-desktop-components-PreferencesWindow-components-CachingReloadPromptModal-CachingReloadPromptModal-module__buttons-AOslbi\"}";
        // 1793873552637
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  